export default __webpack_public_path__ + "static/fonts/group-2.svg";